import React, {useState, useEffect} from 'react';
import {
  View, 
  FlatList, 
  ActivityIndicator, 
  StyleSheet, 
  TouchableOpacity, 
  Text, 
  Image, 
  Modal,
  Dimensions
} from 'react-native';
import {Button} from 'react-bootstrap';
import {listApplicableBasePacks, getGenreWiseChannelsByBouquet} from '../../network/Network';
import info from '../../assets/images/info.png';
import check from '../../assets/images/check.png';
import cancel from '../../assets/images/cancel.png';
import Accordion from 'react-bootstrap/Accordion';
import Spinner from 'react-bootstrap/Spinner'
import {Card} from 'react-native-elements';

const HEIGHT = Dimensions.get('window').height
const WIDTH = Dimensions.get('window').width;
const isWeb = WIDTH > 992;

const BasePackListComponent = ({props}) => {

  const [broadCastPacks, setBroadCastPacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [channelData, setChannelData] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [modalLoading, setModalLoading] = useState([]);

  useEffect(() => {
    setLoading(true);
    listApplicableBasePacks()
    .then((json) => {
      setBroadCastPacks(json.data);
      setLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setLoading(false);
    });
  }, []);

  const getChannelList = (bouque_id) => {
    setModalLoading(true);
    getGenreWiseChannelsByBouquet(bouque_id)
    .then((json) => {
      setChannelData(json);
      setChannelList(json.data.channels);
      setModalLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setModalLoading(false);
    });
  }

  const renderItem = ({item, index}) => {
    return (
      <View style={styles.box}>
        <View style={styles.headerHolder}>
          <Text style={styles.boxHeader}>{item.description}</Text>
          <TouchableOpacity
            onPress={() => {
              getChannelList(item.id);
              setModalVisible(true);
            }}>
            <Image source={info} style={styles.info} />
          </TouchableOpacity>
        </View>
        <Text style={styles.price}>
          {'\u20B9'}
          <Text style={styles.priceAmount}> {item.mrp}</Text>/month
        </Text>
        <View style={styles.responsiveDescription}>
          <View style={styles.sdcount}>
            <Image source={check} style={styles.check} />
            <Text style={styles.features}>{item.boxtype_lbl}</Text>
          </View>
          {/* <View style={styles.desc}>
            <Image source={check} style={styles.check} />
            <Text style={styles.features}>
              Best Of Entertainment, News
            </Text>
          </View> */}
        </View>
        <Text style={styles.footer}>
          Network Capacity Fee extra as applicable
        </Text>
      </View>
    );
  };

  const renderChannelCard = ({item, index}) => {
    return (
      <View style={{ elevation: 8, borderWidth: 1, borderColor: 'grey', borderRadius: 8, flexDirection: 'column', width: '18%', margin: 8, padding: 8 }}>
        {/* <Image source={{ uri: item.logo_url }} style={{ height: 90, width: 90}}/> */}
        <Text style={{ flex:1 }}>{item.name}</Text>
      </View>
    );
  }

  return (
    <View>
      {
        loading 
        ? 
          <ActivityIndicator size="large" />
        :
        <>
        {
          broadCastPacks.length > 0 
          ? (
            <FlatList
              data={broadCastPacks}
              numColumns={Math.round(WIDTH/350)}
              keyExtractor={item => item.id.toString()}
              renderItem={renderItem}
            />
          ) : (
            <Text style={{ color: 'white' }}>No Base packs are available.</Text>
          )
        }
        <Modal animationType="slide" transparent={true} visible={modalVisible}>
          <View style={styles.modalContainer}>
            <View style={styles.modalBox}>
              <TouchableOpacity onPress={() => setModalVisible(false)}>
                <Image source={cancel} style={styles.cancelIcon} />
              </TouchableOpacity>
              <Text style={styles.modalHeader}>{channelData.name || ''}</Text>
              <View style={styles.channelContainer}>
              { modalLoading 
                ? (
                  <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                    <Spinner animation="border" variant={'primary'}/>
                    <Text style={{ color: 'white', marginTop: 8 }}>Loading...</Text>
                  </View>
                  ) 
                : (
                  <Accordion defaultActiveKey="0" style={{ width: '100%' }}>
                    {
                      channelList.map((obj) => {
                        return (
                          <Card key={obj.genre_id}>
                            <Accordion.Toggle as={Button} variant="Button" eventKey={obj.genre_id}>
                              {obj.genre_name}
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={obj.genre_id}>
                              <FlatList
                                data={obj.channel_list}
                                keyExtractor={item => item.id.toString()}
                                renderItem={renderChannelCard}
                                numColumns={5}
                              />
                            </Accordion.Collapse>
                          </Card>
                        );
                      })
                    }
                  </Accordion>
                )
              } 
              </View>
            </View>
          </View>
        </Modal>
      </>
      }
    </View>
  );
};

const styles = StyleSheet.create({
  search: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    backgroundColor: '#36353ca6',
    alignItems: 'center',
    padding: 10,
    borderRadius: 4,
    marginRight: 20,
    marginBottom: 30,
  },
  input: {
    width: 300,
    color: '#cdcddaf5',
  },
  searchIcon: {
    width: 15,
    height: 15,
    alignSelf: 'flex-end',
  },
  headerHolder: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
  box: {
    boxShadow: `${0}px ${0}px ${12}px ${'#8080803b'}`,
    padding: 20,
    margin: 16,
    width: ((WIDTH - 100) / 5)
  },
  boxHeader: {
    color: '#cdcddaf5',
    fontWeight: 400,
    letterSpacing: 1,
    fontSize: 13.4,
    marginRight: 4,
    // fontFamily: font1,
  },
  price: {
    alignSelf: 'center',
    marginTop: 25,
    fontSize: 16,
    color: '#fd6060',
    // fontFamily: font1,
  },
  priceAmount: {
    fontSize: 30,
    // fontFamily: font1,
  },
  desc: {
    flexDirection: 'row',
    marginTop: 5,
  },
  sdcount: {
    flexDirection: 'row',
    marginTop: 13,
  },
  check: {
    width: 14,
    height: 14,
    marginTop: 5,
    marginRight: 10,
  },
  features: {
    fontSize: 13,
    letterSpacing: 0.4,
    color: '#bcbbc7e6',
    // fontFamily: font1,
  },
  footer: {
    color: '#cdcddaf5',
    fontSize: 12,
    alignSelf: 'center',
    marginTop: 40,
  },
  responsiveDescription: {
    height: 70,
    justifyContent: 'center',
    paddingTop: 10,
  },
  button: {
    borderWidth: 1,
    borderColor: '#0092ed',
    alignSelf: 'center',
    marginVertical: 40,
    paddingHorizontal: 15,
    paddingVertical: 9,
    boxShadow: `${0}px ${1}px ${10}px ${'#8080803b'}`,
  },
  buttonText: {
    fontSize: 13,
    color: '#0092edc9',
    fontWeight: 'bold',
    letterSpacing: 1,
  },
  modalContainer: {
    backgroundColor: '#44444470',
    flex: 1,
  },
  modalBox: {
    backgroundColor: '#1a191f',
    borderRadius: 5,
    marginHorizontal: isWeb ? 250 : 15,
    marginTop: isWeb ? 40 : 15,
    padding: 20,
  },
  cancelIcon: {
    width: 20,
    height: 20,
    alignSelf: 'flex-end',
  },
  modalHeader: {
    alignSelf: 'center',
    fontSize: isWeb ? 17 : 13,
    letterSpacing: 1,
    color: '#cdcddaf5',
    fontWeight: 'bold',
  },
  channelContainer: {
    margin: 16,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  channel: {
    marginRight: 20,
    marginBottom: 20,
  },
  channelLogo: {
    width: 45,
    height: 45,
  },
  logoHolder: {
    borderColor: '#efefef1c',
    borderWidth: 1,
    alignItems: 'center',
    paddingHorizontal: 35,
    paddingVertical: 9,
  },
  channelName: {
    alignSelf: 'center',
    marginTop: 7,
    fontSize: 11,
    color: '#bcbbc7e6',
  },
  channelImage: {
    width: 100,
    height: 75,
    marginTop: 20,
    alignSelf: 'center',
  },
  info: {
    width: 16,
    height: 16,
    marginLeft: 8,
  },
  viewStyle: {
    height: HEIGHT,
  },
});

export default BasePackListComponent;
